<p class="color-gray-300 h4-500 mb-4">Email address</p>

<input
  #primaryEmailInput
  [formControl]="primaryEmailControl"
  (input)="onPrimaryEmailInput(primaryEmailInput.value)"
  class="form-input mt-2"
  type="email"
  [ngClass]="{ 'form-input--invalid': primaryEmailControl.errors && (primaryEmailControl.touched || primaryEmailControl.dirty) }"
  data-cy="primary-recipient-email"
/>
<ng-container [ngTemplateOutlet]="emailErrorMessageTemplate" [ngTemplateOutletContext]="{ $implicit: primaryEmailControl }">
</ng-container>

<mat-hint
  *ngIf="!(primaryEmailControl.errors && (primaryEmailControl.touched || primaryEmailControl.dirty))"
  class="small-300 mt-2 color-gray-400 d-block"
>
  A receipt of the payment will be sent to this address.
</mat-hint>

<!--
  Passive projection slot rendered between the primary email and the additional recipients. Consumers that project
  nothing render exactly as before. Email-first checkout projects the payment methods here so the payer must enter a
  valid email before the methods, without this shared component knowing anything about payments.
-->
<ng-content></ng-content>

<p class="color-gray-300 mt-4">
  Additional email recipients (optional)
</p>
<ng-container *ngFor="let additionalEmailRecipientControl of additionalEmailsFormArray.controls; let index = index">
  <div
    class="d-flex align-items-center mt-2 form-input ps-3"
    [ngClass]="{ 'form-input--invalid': additionalEmailRecipientControl.errors && (additionalEmailRecipientControl.touched || additionalEmailRecipientControl.dirty) }"
  >
    <input
      type="email"
      [formControl]="additionalEmailRecipientControl"
      class="flex-fill"
      [attr.data-cy]="'additional-recipient-email-' + index"
    />
    <aiwyn-icon
      name="x-circle"
      class="cursor-pointer ms-2 color-gray-700"
      (click)="removeAdditionalEmailControl(index)"
      [attr.data-cy]="'remove-additional-recipient-email-' + index"
    ></aiwyn-icon>
  </div>

  <ng-container [ngTemplateOutlet]="emailErrorMessageTemplate" [ngTemplateOutletContext]="{ $implicit: additionalEmailRecipientControl }">
  </ng-container>
</ng-container>

<button
  andButton
  color="ghost-secondary"
  size="small"
  [disabled]="isDisabled === true || isDisabled === 'additional' || additionalEmailsFormArray.controls?.length >= 20"
  class="mt-2 w-fit-content"
  (click)="addAdditionalEmailControl()"
  [attr.data-cy]="additionalEmailsFormArray.controls.length === 0 ? 'send-receipt-to-additional-addresses-button' : 'add-email-button'"
>
  <aiwyn-icon name="plus-circle" width="12" height="12" class="me-1"></aiwyn-icon>
  {{ additionalEmailsFormArray.controls.length === 0 ? 'Send receipt to additional addresses' : 'Add email' }}
</button>

<ng-template #emailErrorMessageTemplate let-formControl>
  <ng-container *ngIf="formControl.invalid && (formControl.touched || formControl.dirty)">
    <mat-error *ngIf="formControl.errors.required" class="d-block small-300 color-red-200 mt-2">
      Email is required.
    </mat-error>

    <mat-error *ngIf="formControl.errors.email" class="d-block small-300 color-red-200 mt-2">
      Invalid email.
    </mat-error>
  </ng-container>
</ng-template>
